import React from 'react';
import ReactDOM from 'react-dom/client';
import FakeStore from './Components/FS/FakeStore';
import './main.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <FakeStore />
  </React.StrictMode>
);